import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pricing-update"
export default class extends Controller {
  static values = { pricing: Object }

  connect() {
    this.update()
  }

  update() {
    // Dispatch an event to inform other controllers that we
    // refreshed the pricing.
    this.dispatch("pricing", {
      detail: this.pricingValue
    });
  }
}
